export default __webpack_public_path__ + "final-cut-pro.1f311e74.png";